<template>
    
</template>
  
<script>
import { updateStoreData } from '@/composables/store';
import router from '@/router';
import { onMounted } from 'vue';

export default {
setup() {
    onMounted(async () => {
        const success = await updateStoreData()
        if (success === false) {
            router.push("/login")
        }else {
            router.push("/dashboard")
        }
    });
},
};
</script>
  
<style>
</style>
  